import React, { useEffect, useState } from 'react';
import LangStorageManager from '../lang/LangStorageManager';
import LanguageManager from '../lang/LanguageManager';
import './contact.css';

export default function Contact() {
    const storage = new LangStorageManager(null);
    const [language, setLanguage] = useState(storage.getStorage());
    const [texts, setTexts] = useState(null);

    const [form, setForm] = useState({
        subject: '',
        email: '',
        message: ''
    });

    const [response, setResponse] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://platform.linkedin.com/badges/js/profile.js';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    }, []);

    useEffect(() => {
        const loadText = async () => {
            const translator = new LanguageManager(language);
            await translator.loadTranslation();
            setTexts(translator.getAll());
        };
        loadText();
    }, [language]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponse('');
        setErrors({});

        try {
            const res = await fetch(process.env.REACT_APP_API_FORM_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(form)
              });              

            if (!res.ok) {
                if (res.status === 400) {
                    const data = await res.json();
                    setErrors(data);
                } else {
                    setResponse('There was an error sending the email, please try again later');
                }
            } else {
                const data = await res.json();
                setResponse(data.message || 'Message sent successfully');
                setForm({ subject: '', email: '', message: '' });
                if ('vibrate' in navigator) navigator.vibrate([2000, 1000, 2000]);
            }
        } catch (err) {
            setResponse('There was an error sending the email, please try again later');
        } finally {
            setLoading(false);
        }
    };

    const [validFields, setValidFields] = useState({
        subject: false,
        email: false,
        message: false
    });

    const [botonHabilitado, setBotonHabilitado] = useState(false);

    const regex = {
        subject: /^[^\n\r\t]{4,100}$/,
        email: /^(?!.*[\n\r\t])[^@\s]+@[^@\s]+\.[^@\s]+$/,
        message: /^(?!.*[\r\t]).{4,8000}$/
    };

    const handleChangeInput = (e) => {
        const { name, value } = e.target;

        setForm(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: null }));

        let isSubjectValid = validFields.subject;
        let isEmailValid = validFields.email;
        let isMessageValid = validFields.message;

        if (name === 'subject') {
            isSubjectValid = regex.subject.test(value);
        } else if (name === 'email') {
            isEmailValid = regex.email.test(value);
        } else if (name === 'message') {
            isMessageValid = regex.message.test(value);
        }

        setValidFields({
            subject: isSubjectValid,
            email: isEmailValid,
            message: isMessageValid
        });

        validate(isSubjectValid, isEmailValid, isMessageValid);
    };

    const validate = (subj, mail, msg) => {
        if (subj && mail && msg) {
            setBotonHabilitado(true);
            setResponse('');
        } else {
            setBotonHabilitado(false);
            setResponse('Please complete all fields correctly');
        }
    };

    return (
        <section id="contact">
            <h3>{texts?.contact?.title || 'Contact me!'}</h3>

            <nav>
                <div className='badge-base LI-profile-badge' data-locale='es_ES' data-size='medium' data-theme='dark' data-type='VERTICAL' data-vanity='nahuel-tellechea-freire-818a77210' data-version='v1'>
                    <a href="https://uy.linkedin.com/in/nahuel-tellechea-freire-818a77210?trk=profile-badge" className='badge-base__link LI-simple-link' target='_blank' rel='noreferrer'></a>
                </div>
            </nav>

            <hr />

            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="subject"
                    placeholder={texts?.contact?.form?.subject || 'Title of your message....'}
                    value={form.subject}
                    onChange={handleChangeInput}
                    required
                />

                <input
                    type="text"
                    name="email"
                    placeholder={texts?.contact?.form?.email || 'Your email....'}
                    value={form.email}
                    onChange={handleChangeInput}
                    required
                />

                <textarea
                    name="message"
                    placeholder={texts?.contact?.form?.message || 'Message....'}
                    value={form.message}
                    onChange={handleChangeInput}
                    required
                />

                <input
                    type="submit"
                    value={loading ? 'Sending....' : (texts?.contact?.form?.send || 'Send message')}
                    disabled={loading || !botonHabilitado}
                />

                {response && <p className='response'>{response}</p>}
            </form>
        </section>
    );
}